import { Box, useColorModeValue } from "@chakra-ui/react";

export default function ScrollBox({
  height,
  maxHeight = "100%",
  children,
  reference,
  ...rest
}) {
  const bg = useColorModeValue("black20", "white40");
  return (
    <Box
      ref={reference}
      height={height || "initial"}
      maxHeight={maxHeight || "initial"}
      overflowY="auto"
      sx={{
        "::-webkit-scrollbar-track": { display: "none" },
        "::-webkit-scrollbar": { width: "4px" },
        "::-webkit-scrollbar-thumb": {
          borderRadius: "3px",
          backgroundColor: bg
        }
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}
